import type { ComponentBaseMapper, TriggerRenderer, EventStateRegistry } from "../types";
import { baseMapper } from "./base";
import { buildActionStateRegistry } from "../eventDisplay";
import { createRepositorySandboxMapper } from "./create_repository_sandbox";
import { EXECUTE_COMMAND_STATE_REGISTRY } from "./execute_command";

export const componentMappers: Record<string, ComponentBaseMapper> = {
  createSandbox: baseMapper,
  createRepositorySandbox: createRepositorySandboxMapper,
  getPreviewUrl: baseMapper,
  executeCode: baseMapper,
  executeCommand: baseMapper,
  deleteSandbox: baseMapper,
};

export const triggerRenderers: Record<string, TriggerRenderer> = {};

export const eventStateRegistry: Record<string, EventStateRegistry> = {
  createSandbox: buildActionStateRegistry("created"),
  createRepositorySandbox: buildActionStateRegistry("created"),
  getPreviewUrl: buildActionStateRegistry("generated"),
  executeCode: EXECUTE_COMMAND_STATE_REGISTRY,
  executeCommand: EXECUTE_COMMAND_STATE_REGISTRY,
  deleteSandbox: buildActionStateRegistry("deleted"),
};
